
export class Item {
    constructor(
        public title: string,
        public subtitle: string,
        public releaseDate: Date,
        public image: any) {
    }
}